"use client"
import Community from "@/ui/Component/Community"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import React from "react"

const StyledCommunityWrapper = styled(Box)`
  padding-top: 8%;
  width: 100%;
  height: 100%;
`

type ErrorPageProps = {
  data: any
}
const ErrorPage: React.FC<ErrorPageProps> = ({ data }) => {
  return (
    <>
      <StyledCommunityWrapper>
        <Community data={data} />
      </StyledCommunityWrapper>
    </>
  )
}
export default ErrorPage
